<template>
  <ui-dealer-address v-if="isVisible">
    <template #name>
      {{ dealerName }}
      <footnote-reference
        v-if="showDealerLocationFootnote"
        :text="props.footnoteLabel"
        :reference="generateReference('dealerLocation')"
      />
    </template>
    <template v-if="dealerAddress" #address>{{ dealerAddress }}</template>
  </ui-dealer-address>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { useFootnoteReference } from '../../../composables/footnote-reference.composable';
import { infuse } from '../../../ioc-config';
import { useDealerInfo } from '../../../composables/dealer-info.composable';
import Vehicle from '../../../models/vehicle.model';
import FootnoteReference from '@dh-io-emh/shared/src/components/footnotes/footnoteReference.vue';
import UiDealerAddress from '@dh-io-emh/ui/src/elements/dealerAddress/DealerAddress.vue';

export default defineComponent({ name: 'DealerDisplay' });
</script>

<script lang="ts" setup>
const props = defineProps({
  footnoteLabel: {
    type: String,
    required: true,
  },
  product: {
    type: Object as PropType<Vehicle>,
    required: true,
  },
});

const {
  srp: { showDealerName, showConsignorCompany },
  footnotes: { showDealerLocationFootnote },
} = infuse('config');
const { generateReference } = useFootnoteReference('productTile');
const isVisible = computed(() => showDealerName || showConsignorCompany);
const dealerName = computed(() => {
  if (showConsignorCompany && props.product.consignorCompanyDisplayName) {
    return props.product.consignorCompanyDisplayName;
  }

  const { dealerName } = useDealerInfo(props.product);

  return dealerName.value;
});
const dealerAddress = computed(() => {
  if (showConsignorCompany) {
    return undefined;
  }

  const { dealerAddress } = useDealerInfo(props.product);

  return dealerAddress.value;
});
</script>
